import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function ArticleInfo({article}) {
  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : '';
  return (
    <div className="card info">
      <h1>
        {article.title || article.slug }&nbsp;
        <a target="_blank" rel="noreferrer" href={apiBase + '/api/articles/' + article.id + '/redirect'}><Image className="link" src="/external-link.svg" /></a>
      </h1>
      <Container>
        <Row>
          <Col>
            <p>
              Products: <span className="value">
                {article.product_ids && article.product_ids.length > 0 
                  ? article.product_ids.map((id, idx) => (
                      <span key={id}>
                        <Link to={'/products/' + id}>{article.product_names[idx]}</Link>
                        {idx < article.product_ids.length - 1 && ', '}
                      </span>
                    ))
                  : 'None'
                }
              </span><br />
              {article.slug && !article.slug.startsWith('doc!') && !article.slug.startsWith('dsg!') &&
                <>
                  Author: <span className="value">{article.author_id && <Link to={'/authors/' + article.author_id}>{article.author_name}</Link>}</span><br />
                  Team: <span className="value">{article.team_id && <Link to={'/teams/' + article.team_id}>{article.team_name}</Link>}</span><br />
                  Computer Language: <span className="value">{article.language_id && <Link to={'/languages/' + article.language_id}>{article.language_name}</Link>}</span><br />
                  Human Language: <span className="value">{article.human_language_id && <Link to={'/human_languages/' + article.human_language_id}>{article.human_language_name}</Link>}</span><br />
                  Publication date: <span className="value">{article.date && moment(article.date).format('LL') + ' (' + moment(article.date).fromNow() + ')'}</span><br />
                </>
              }
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
